import { httpRequest } from '../../../../app/common/util/api-common.util';

class RecebimentoMaterialApi {
  static getFiltrosMaterial() {
    return httpRequest('recebimentomaterial/filtros');
  }

  static getBloqueioRecebimentoMaterial(laudo) {
    return httpRequest(`checklist/laudo/${laudo}/bloqueio-recebimento`).then(
      (json) => json.data
    );
  }

  static finalizarRecebimentoMaterial(laudo, finaliza = false) {
    return httpRequest(`laudos/${laudo}/etapas/material`, 'PATCH', {
      finalizarRecebimento: finaliza,
    }).then((json) => json);
  }

  static getConfiguracoesRecebimentoMaterial() {
    return httpRequest('configuracoes/material').then((json) => json.data);
  }

  static registrarRecolhimentoLaudos(request) {
    return httpRequest(`rastreabilidade/`, 'POST', request).then(
      (json) => json.data
    );
  }
}

export default RecebimentoMaterialApi;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/material.api.js